export type CommunityAggregateRow = {
  secondAoiTypeId?: number;
  secondAoiTypeName?: string;
  totalHouseholds?: number;
  avgPrice?: number;
  weightedHomeNumber?: number;
  weightedHomeNumberRatio?: number | null;
  avgBuildYear?: number | null;
};

/** aggListV2 将总计与类型明细分开返回，表格按总计优先展示。 */
export function toCommunityAggregateRows(response: {
  total?: CommunityAggregateRow | null;
  items?: CommunityAggregateRow[] | null;
}): CommunityAggregateRow[] {
  return [
    ...(response?.total ? [response.total] : []),
    ...(Array.isArray(response?.items) ? response.items : []),
  ];
}
